import { VendorStockDetailPage } from "@/features/vendor-app/pages/VendorStockDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/stock/$productID/")({
	component: VendorStockDetailPage,
});
